export function createAndAppendInHeaderElement(tagName, sideEffect) {
    const el = document.createElement(tagName);
    if (sideEffect && typeof sideEffect === 'function') {
        try {
            sideEffect(el);
        }
        catch (error) {
            console.error('call side effect error', error);
        }
    }
    document.head.appendChild(el);
    return el;
}
export function createAndApplyStyle(css) {
    createAndAppendInHeaderElement('style', (el) => applyStyle(el, css));
}
export function applyStyle(target, css) {
    target.textContent = css.cssText;
}
export function buildEvent(type, value, event) {
    return new CustomEvent(type, { bubbles: true, composed: true, detail: { value, event } });
}
export function dispatchEvent(ctx, type, value, event) {
    ctx.dispatchEvent(buildEvent(type, value, event));
}
export function dispatchUiFallback(ctx, event) {
    dispatchEvent(ctx, 'ui-fallback', ctx, event);
}
export function vibrate(pattern = 40) {
    try {
        navigator.vibrate(pattern);
    }
    catch {
        //
    }
}
//# sourceMappingURL=dom.utils.js.map